import { useQuery } from "react-query";
import { getProducerCodeCount } from "../../../../actions/CarrierAgreementMgmt/ProducerCodeConfig";

export const useGetProducerCodeCount = () => {
  return useQuery("GetProducerCodeCount", getProducerCodeCount, {
    refetchOnWindowFocus: false,
  });
};
